import React from "react";
const VideoBox = props => {
    const mystyle = {
        width: '17rem'
    };
    const vButton = {
        color: '#1ba7ae6c',
        position: "absolute",
        top: '50%',
        right: '40%',
        transform: 'translate(-50%,-50%)'
    }
    const videoLink = '';
    return (
        <>
            <div className="card-sm">
                <a href={props.videoLink} target="_blank" style={{ position: "relative" }}>
                    <i className='fa fa-caret-right fa-5x' style={vButton}></i>
                    <img src={props.imgLink} style={mystyle} alt="img" target="_blank" />
                </a>
            </div>
            <a href={props.videoLink} target="_blank" >
                <u>{props.heading}<i className="webconnect webconnect-box-arrow-up-right pt-2"></i></u>
            </a>
        </>
    );
};
export default VideoBox;
